export enum Language {
  HR = "hr",
  EN = "en",
  IT = "it",
  DE = "de",
  SL = "sl",
  SR = "sr",
  CS = "cs",
}

// localStorage key for the user's selected language. Mirrors i18next's default
// detection key so it stays in sync with any cached value.
export const LANGUAGE_STORAGE_KEY = "i18nextLng";
